import React from 'react';
import classnames from 'classnames';
import './VenueAnalysisGrid.scss';
import { VenueAnalysisData } from '../venueAnalysisAggregatedData';
import './OrderLiquidityBreakdown.scss';

import { VenueAnalysisConfigurationState } from '../store/configuration/VenueAnalysisConfigurationState';

import { OrderLiquidityBar } from 'widgets/venueAnalysis/grid/OrderLiquidityBar';
import { VenueAnalysisSelection } from 'widgets/venueAnalysis/store/component/VenueAnalysisSelection';
import { OrderLiquidityVenueSankey } from 'widgets/venueAnalysis/grid/OrderLiquidityVenueSankey';

interface OrderLiquidityBreakdownProps {
    data: VenueAnalysisData;
    config: VenueAnalysisConfigurationState;
    selection?: VenueAnalysisSelection;
    width: number;
}

export function OrderLiquidityBreakdown({
    data,
    config,
    selection,
    width,
}: OrderLiquidityBreakdownProps) {
    const isVisible = config.visibleSections.orders;

    const orderLiquidity = data.orderLiquidity || [];

    return (
        <div className="OrderLiquidityBreakdown">
            {isVisible && orderLiquidity.length > 0 && (
                <>
                    <OrderLiquidityVenueSankey
                        data={data}
                        selection={selection}
                        width={width}
                    />
                    <div className="grid-row liquidity-bar-row">
                        <div className="labels venue-bar-label">Liquidity</div>
                        <div className={classnames('content')}>
                            {orderLiquidity.map((liquidity) => (
                                <OrderLiquidityBar
                                    data={liquidity}
                                    width={width}
                                    key={liquidity.liquidity.name}
                                />
                            ))}
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}
